import React from 'react';
import Model from '../common/models/Model';
import { Button } from '../common/Button';
import useI18n from '../../hooks/useI18n';
import { useNavigate } from 'react-router-dom';
import IconButton from '../common/IconButton';

interface SaveAsDraftModalProps {
  isOpen: boolean;
  onClose: () => void;
  handleStay: () => void;
  handleLeave: () => void;
}

const SaveAsDraftModal: React.FC<SaveAsDraftModalProps> = ({
  isOpen,
  onClose,
  handleStay,
  handleLeave,
}) => {
  const { t } = useI18n();
  const navigate = useNavigate();
  return (
    <Model
      isOpen={isOpen}
      className="!bg-black !bg-opacity-40"
      onClose={handleStay}
    >
      <div className="flex flex-col w-[21rem]">
        <div className="flex justify-between">
          <h1 className="font-semibold text-lg font-content">Save Your Work</h1>
          <IconButton
            src="/assets/svgs/fi_cross.svg"
            onClick={onClose}
            className="size-50"
          />
        </div>
        <div className="my-4 text-base">
          Would you like to save your current progress as a draft before
          exiting?
        </div>
        <div className="flex justify-between gap-2">
          <Button variant="outlined" onClick={handleStay} className="flex-1">
            {t('common.cancel')}
          </Button>
          <Button onClick={handleLeave} className="flex-1">
            Save As Draft
          </Button>
        </div>
      </div>
    </Model>
  );
};

export default SaveAsDraftModal;
